export const SHOP_SETTINGS_COLLECTION = 'shop-config'
export const SHOP_SETTINGS_DOC = 'global'
export const SHOP_PRODUCTS_COLLECTION = 'shop-products'
export const SHOP_ORDERS_COLLECTION = 'shop-orders'
export const DEFAULT_SHOP_CATEGORIES = ['Uniform', 'Sports', 'Music', 'Gymnastics', 'Yoga']

export const toNumber = (value) => {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : 0
}

export const formatCurrency = (value) => `$${toNumber(value).toFixed(2)}`

export const getProductStock = (product) => {
    if (!product) return 0
    if (product.hasVariants && Array.isArray(product.variants)) {
        return product.variants.reduce((sum, variant) => sum + Math.max(0, parseInt(variant.quantity || 0)), 0)
    }
    return Math.max(0, parseInt(product.quantity || 0))
}

export const getVariantLabel = (variant) => {
    const parts = [variant && variant.name, variant && variant.value].filter(Boolean)
    return parts.join(': ')
}

export const getProductImages = (product) => {
    if (!product) return []
    if (Array.isArray(product.images)) {
        const urls = product.images.map((url) => (url || '').trim()).filter(Boolean)
        if (urls.length > 0) return urls
    }
    const fallback = (product.image || '').trim()
    return fallback ? [fallback] : []
}

export const getPrimaryProductImage = (product) => {
    const images = getProductImages(product)
    return images.length > 0 ? images[0] : ''
}

export const getCartSummary = (items = [], deliveryFee = 0) => {
    const subtotal = items.reduce((sum, row) => sum + (toNumber(row.price) * Math.max(1, parseInt(row.quantity || 1))), 0)
    const shipping = toNumber(deliveryFee)
    const total = subtotal + shipping
    return { subtotal, shipping, total }
}

export const getProductDisplayPrice = (product) => {
    if (!product) return 0
    const basePrice = toNumber(product.price)
    if (!product.hasVariants || !Array.isArray(product.variants)) {
        return basePrice
    }

    const variantPrices = product.variants
        .map((variant) => {
            const variantPrice = toNumber(variant.price)
            return variantPrice > 0 ? variantPrice : basePrice
        })
        .filter((price) => price > 0)

    if (variantPrices.length === 0) {
        return basePrice
    }
    return Math.min(...variantPrices)
}
